import { Injectable } from '@angular/core';
import { ClassStudentQuery } from '@examdojo/class';
import { QueryEntity } from '@examdojo/state';
import { Observable } from 'rxjs';
import { StudentClassAssignmentQuery } from '../student-class-assignment/student-class-assignment.query';
import { StudentClassStoreModel, StudentClassUIModel } from './student-class.model';
import { StudentClassState, StudentClassStore } from './student-class.store';

@Injectable({ providedIn: 'root' })
export class StudentClassQuery extends QueryEntity<
  StudentClassState,
  StudentClassStoreModel,
  StudentClassUIModel,
  'id'
> {
  constructor(
    protected override readonly store: StudentClassStore,
    private readonly studentClassAssignmentQuery: StudentClassAssignmentQuery,
    private readonly classStudentQuery: ClassStudentQuery,
  ) {
    super(
      store,
      () => [studentClassAssignmentQuery.entities$, classStudentQuery.entities$],
      () => [studentClassAssignmentQuery.entities$, classStudentQuery.entities$],
      (entity: StudentClassStoreModel): StudentClassUIModel => {
        const nameParts = [entity.teacher_title, entity.teacher_first_name, entity.teacher_last_name].filter(Boolean);

        return {
          ...entity,
          students: this.classStudentQuery.getByClassId(entity.id),
          todoAssignments: this.studentClassAssignmentQuery.getTodoByClassId(entity.id),
          doneAssignments: this.studentClassAssignmentQuery.getDoneByClassId(entity.id),
          teacherName: nameParts.length > 0 ? nameParts.join(' ') : null,
        };
      },
    );
  }

  selectInitialized(): Observable<boolean> {
    return this.selectProp('initialized');
  }

  isInitialized(): boolean {
    return this.getProp('initialized');
  }
}
